import Api from "@/services/Api";

export default {
  indexByCampaign(campaignId) {
    return Api().get("scenarios/by_campaign/" + campaignId);
  },
  indexByParty(partyId) {
    return Api().get("scenarios/by_party/" + partyId);
  },
  store(form) {
    return Api().post("scenarios", form);
  },
  detachedByCampaign(campaignId) {
    return Api().get("scenarios/" + campaignId + "/detached_by_campaign");
  },
  view(scenarioId) {
    return Api().get("scenarios/" + scenarioId);
  },
  completeByParty(scenarioId, partyId) {
    return Api().put("scenarios/" + scenarioId + "/complete_by_party", {
      party_id: partyId
    });
  }
};